import { render, staticRenderFns } from "./UserOrderDetail.vue?vue&type=template&id=1fc75e0d&"
import script from "./UserOrderDetail.vue?vue&type=script&lang=js&"
export * from "./UserOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserOrderDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports